<template lang="pug">
  div
  // закоментрировано из-за медл обработки pug -> html -> js
  //div.charts-new
    div.toolbar
      div.line
        h1.title Аналитика
        div.view-panel
          button.view-panel__button.view-table
          button.view-panel__button.view-chart.active


    div.dashboard
      div.col
        div.chart-block
          div.chart-block__head
            div.chart-block__head-title Кассовые выплаты по доходам
            div.card-options
              div.card.card-open
              div.card.card-close
          div.chart-block__body
            div.chart-block__body-toolbar
              div.defaultSelect.part-3-from-4
                select
                  option 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет

              div.defaultSelect.part-1-from-4
                select
                  option 15 лет
                  option 16 лет
            div.chart-pic
              img(src="~img/back_tko.jpg")


      div.col
        div.chart-block
          div.chart-block__head
            div.chart-block__head-title Кассовые выплаты по доходам
            div.card-options
              div.card.card-open
              div.card.card-close
          div.chart-block__body
            div.chart-block__body-toolbar
              div.defaultSelect.part-3-from-4
                select
                  option 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет
                  option 16 лет

              div.defaultSelect.part-1-from-4
                select
                  option 15 лет
                  option 16 лет
            div.chart-pic
              img(src="~img/licence-big.jpg")

      div.col
        div.chart-block
          div.chart-block__head
            div.chart-block__head-title Обращения граждан за 2017 год по статусу
            div.card-options
              div.card.card-open
              div.card.card-close
          div.chart-block__body
            div.chart-block__body-toolbar
              div.part-3-from-4
              div.part-1-from-4
                div.view-panel
                  button.view-panel__button.view-table
                  button.view-panel__button.view-chart.active
            div.chart-pic
              img(src="~img/user-img.png")

        div.chart-block
          div.chart-block__head
            div.chart-block__head-title Кассовые выплаты по доходам
            div.card-options
              div.card.card-open
              div.card.card-close
          div.chart-block__body
            div.chart-block__body-toolbar
              div.customSelect.part-3-from-4
                input.customSelect__select(@click="showList = !showList" value="Целевой показатель")
                span.choose
                div.customSelect__list.cuscroll(:class="showList ? 'open' : 'close'")
                  ul
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
                    li
                      div
                        span Название 1 54d5f4d5f454fdf45df4 54dd 5df4dff
              div.default-select.part-1-from-4
                select
                  option 15 лет
                  option 16 лет
            div.chart-pic
              img(src="~img/back_tko.jpg")



    // открытая карточка
    div.col.col--full-width
      div.chart-block
        div.chart-block__head
          div.chart-block__head-title Кассовые выплаты по доходам
          div.card-options
            div.card.card-open
            div.card.card-close
        div.chart-block__body
          div.chart-block__body-toolbar
            div.defaultSelect.part-3-from-4
              select
                option 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет 15 лет
                option 16 лет
                option 16 лет
                option 16 лет
                option 16 лет
                option 16 лет
                option 16 лет

            div.defaultSelect.part-1-from-4
              select
                option 15 лет
                option 16 лет
          div.chart-pic
            img(src="~img/back_tko.jpg")





</template>

<script>

  export default {
    data () {
      return {
        showList: false
      }
    },
  }

</script>
